import { ResourceType } from '../components/MenuTicket/types';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import FilterAction from 'redux/actions/filterAction';
import { RootState } from 'redux/store';
import { useUserData } from './useUserData';

export const useTicketFilter = (activeTab: ResourceType) => {
  const { t } = useTranslation(['requests']);
  const userData = useUserData();

  const dispatch = useDispatch();
  const { dataFilterApproval, dataFilterINC, dataFilterRITM } = useSelector(
    (state: RootState) => state.filterReducer,
  );

  // const getEnabledApprovals = getKeyFeaturesConfig(requestTypes?.features, ResourceType.Approvals);
  const isCheckEnabledApprovals = true;

  // const getEnabledIncidents = getKeyFeaturesConfig(requestTypes?.features, ResourceType.Incidents);
  const isCheckEnabledIncidents = true;

  // const getEnabledRequests = getKeyFeaturesConfig(requestTypes?.features, ResourceType.Requests);
  const isCheckEnabledRequests = true;

  const shouldGetListFilter = (type: ResourceType) => {
    const enabledFeatures = {
      [ResourceType.Approvals]: isCheckEnabledApprovals,
      [ResourceType.Incidents]: isCheckEnabledIncidents,
      [ResourceType.Requests]: isCheckEnabledRequests,
    };
    const dataFilters = {
      [ResourceType.Approvals]: dataFilterApproval,
      [ResourceType.Incidents]: dataFilterINC,
      [ResourceType.Requests]: dataFilterRITM,
    };
    return (
      activeTab === type &&
      enabledFeatures[type] &&
      Object.keys(dataFilters[type]).length === 0
    );
  };

  useEffect(() => {
    const username = userData?.user_name;
    if (!username) return;

    if (shouldGetListFilter(ResourceType.Approvals)) {
      dispatch(FilterAction.getListFilterApproval(username));
    }
    if (shouldGetListFilter(ResourceType.Incidents)) {
      dispatch(FilterAction.getListFilterINC(username));
    }
    if (shouldGetListFilter(ResourceType.Requests)) {
      dispatch(FilterAction.getListFilterRITM(username));
    }
  }, [userData?.user_name, activeTab]);

  const approvalFilter = [
    {
      label: t(`filterLabel.status.approvals`),
      childs: dataFilterApproval?.state || [],
      multiple: true,
      keyName: 'states',
    },
    // {
    //   label: t(`filterLabel.status.approver`),
    //   childs: dataFilterApproval?.approver || [],
    //   multiple: true,
    //   keyName: 'approverSelected',
    // },
    {
      label: t('filterLabel.createdDate'),
      childs: dataFilterApproval?.date_range || [],
      multiple: false,
      keyName: 'date_range',
    },
  ];

  const approvalFilterDelegation = [
    {
      label: t(`filterLabel.status.approvals`),
      childs: dataFilterApproval?.state || [],
      multiple: true,
      keyName: 'states',
    },
    {
      label: t('filterLabel.createdDate'),
      childs: dataFilterApproval?.date_range || [],
      multiple: false,
      keyName: 'date_range',
    },
  ];

  const incidentFilter = [
    {
      label: t(`filterLabel.status.incidents`),
      childs: dataFilterINC?.state || [],
      multiple: true,
      keyName: 'states',
    },
    {
      label: t('filterLabel.createdDate'),
      childs: dataFilterINC?.date_range || [],
      multiple: false,
      keyName: 'date_range',
    },
  ];

  const requestFilter = [
    {
      label: t(`filterLabel.status.requests`),
      childs: dataFilterRITM?.state || [],
      multiple: true,
      keyName: 'states',
    },
    {
      label: t('filterLabel.createdDate'),
      childs: dataFilterRITM?.date_range || [],
      multiple: false,
      keyName: 'date_range',
    },
  ];

  return {
    approvalFilter,
    approvalFilterDelegation,
    incidentFilter,
    requestFilter,
  };
};
